import React from 'react';
import { useLicense } from '../contexts/LicenseContext';

const BANNERS = {
  suspended: { bg: '#A32D2D', icon: '🔒', text: 'Předplatné pozastaveno — data jsou přístupná pouze ke čtení. Pro obnovení kontaktujte PSI Direct.' },
  expired:   { bg: '#A32D2D', icon: '🔒', text: 'Platnost předplatného vypršela — data jsou přístupná pouze ke čtení. Kontaktujte PSI Direct.' },
  grace:     { bg: '#854F0B', icon: '⚠️', text: null },
};

export default function LicenseBanner() {
  const { status, message } = useLicense();
  const banner = BANNERS[status];
  if (!banner) return null;

  return (
    <div style={{
      background: banner.bg,
      color: 'white',
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      fontSize: 14,
      fontWeight: 600,
      zIndex: 1000,
    }}>
      <span>{banner.icon}</span>
      <span>{banner.text || message}</span>
    </div>
  );
}
